import { Component, OnInit } from '@angular/core';
import { DataService } from '../shared/dataservice.service';
import { GenService } from '../shared/gen-ser.service';
import { DrawToken, SearchParamsDraw, Product } from '../shared/misc-classes';
import * as JSZip from 'JSZip';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-drawing-downloader',
  templateUrl: './drawing-downloader.component.html',
  styleUrls: ['./drawing-downloader.component.css']
})
export class DrawingDownloaderComponent implements OnInit {

  searchOptionsDraw: SearchParamsDraw = {
    "filterUploadDate": false,
    "uploadFromDate": new Date(),
    "uploadToDate": new Date(),
    "plantId": "inbt",
    "soOptSelection": "na",
    "pastedSONosStr": "",
    "fromSONo": "",
    "toSONo": "",
    "extractedSONumbers": [],
    "soExtractMessage": "",
    "soNos": []
  }

  showDrawFiles: boolean = false;

  drawTokens: Array<DrawToken> = [];
  isSearching: boolean = false;
  isDownloadMode: boolean = false;
  isDownloadComplete: boolean = false;

  zip = new JSZip();

  _downloadProductListDraw: Array<Product> = []

  constructor(private _dataService: DataService) { }

  ngOnInit() {
    this._downloadProductListDraw = this._dataService.downloadDrawFolderList; // Same access for Upload & Download of Drawing
  }

  getSelectedProductDrawFolders(): Array<string> {
    let _drawFolders: Array<string> = [];
    this._downloadProductListDraw.forEach((_prod: Product) => {
      if (_prod.isSelectedDraw == true) {
        _drawFolders.push(_prod.drawFolder);
      }
    });
    return _drawFolders;
  }
  searchDrawFiles() {
    let _drawFolders: Array<string> = this.getSelectedProductDrawFolders();
    if (_drawFolders.length == 0) {
      alert('Please select atleast one Product to continue.');
      return;
    }

    if (this.searchOptionsDraw.soNos.length == 0 && this.searchOptionsDraw.filterUploadDate == false) {
      alert('Please select atleast Upload Date Filter or SO Number to continue.');
      return;
    }
    this.showDrawFiles = true;
    this.searchSONumbers(_drawFolders);
  }
  showSearchParams() {
    this.showDrawFiles = false;
  }
  getPlaceHolders() {
    let _colspan: number = 4;
    let _phold_count: number = (_colspan - (this._downloadProductListDraw.length % _colspan));
    if (_phold_count == _colspan) return [];

    let _retArray: Array<Number> = [];
    for (var i = 0; i < _phold_count; i++) {
      _retArray.push(i);
    }
    return _retArray;
  }
  searchSONumbers(_rtcFolders: Array<string>) {
    let searchUploadDate: boolean = this.searchOptionsDraw.filterUploadDate;
    let fromDateNum: number = 0;
    let toDateNum: number = 0;
    if (searchUploadDate == true) {
      fromDateNum = GenService.getDateNum(this.searchOptionsDraw.uploadFromDate);
      toDateNum = GenService.getDateNum(this.searchOptionsDraw.uploadToDate);
    }
    this.isSearching = true;
    this._dataService.searchSONumbers(searchUploadDate, fromDateNum, toDateNum, "0", this.searchOptionsDraw.soNos, _rtcFolders)
      .subscribe((_retVal: Array<DrawToken>) => {
        if (_retVal == null) {
          this.drawTokens = [];
        }
        else {
          this.drawTokens = _retVal;
        }
        this.isDownloadMode = false;
        this.isSearching = false;
      });
  }

  getSOCountMessage() {
    if (this.drawTokens.length < 5000)
      return "Showing " + this.drawTokens.length + " Drawing files.";
    else
      return "Showing " + this.drawTokens.length + " of many, please narrow down your search.";
  }

  displayFile(_rtcFile: DrawToken) {
    this._dataService.downloadFile(_rtcFile.relPath, _rtcFile.soNo);


    // zip.file("Hello.txt", "Hello World\n");

    // var img = zip.folder("images");
    // img.file("smile.gif", "", {base64: true});

    // zip.generateAsync({type:"blob"}).then(function(content) {
    //     // see FileSaver.js
    //     saveAs(content, "example.zip");
    // });
  }

  totalDownloadCount: number = 0;
  downloadFileIndex: number = 0;
  downloadZip() {
    this.downloadFileIndex = 0;
    this.isDownloadMode = true;
    this.isDownloadComplete = false;
    this.totalDownloadCount = this.drawTokens.length;
    this.zip = new JSZip();
    this.startDownload();
  }

  startDownload() {
    if (this.downloadFileIndex < this.totalDownloadCount) {
      let _rtcToken: DrawToken = this.drawTokens[this.downloadFileIndex];

      this._dataService.downloadFileContent(_rtcToken.relPath, _rtcToken.soNo)
        .subscribe((_resp: any) => {
          this.zip.file(_rtcToken.soNo + ".pdf", _resp._body, { binary: true });
          this.downloadFileIndex++;
          setTimeout(() => {
            this.startDownload();
          }, 1);
        });
    }
    else {
      this.zip.generateAsync({ type: "blob" }).then((content) => {
        // see FileSaver.js
        saveAs(content, "RTC-downloads.zip");
        this.isDownloadMode = false;
        this.isDownloadComplete = true;
      });
    }
  }


  toUTF8Array(str) {
    var utf8 = [];
    str = str[10];
    for (var i = 0; i < str.length; i++) {
      var charcode = str.charCodeAt(i);
      console.log(charcode);
      if (charcode < 0x80) utf8.push(charcode);
      else if (charcode < 0x800) {
        utf8.push(0xc0 | (charcode >> 6),
          0x80 | (charcode & 0x3f));
      }
      else if (charcode < 0xd800 || charcode >= 0xe000) {
        utf8.push(0xe0 | (charcode >> 12),
          0x80 | ((charcode >> 6) & 0x3f),
          0x80 | (charcode & 0x3f));
      }
      // surrogate pair
      else {
        i++;
        // UTF-16 encodes 0x10000-0x10FFFF by
        // subtracting 0x10000 and splitting the
        // 20 bits of 0x0-0xFFFFF into two halves
        charcode = 0x10000 + (((charcode & 0x3ff) << 10)
          | (str.charCodeAt(i) & 0x3ff))
        utf8.push(0xf0 | (charcode >> 18),
          0x80 | ((charcode >> 12) & 0x3f),
          0x80 | ((charcode >> 6) & 0x3f),
          0x80 | (charcode & 0x3f));
      }
    }
    return utf8;
  }

  getDownloadStatus() {
    if (this.downloadFileIndex >= this.totalDownloadCount) {
      return "Download finished, preparing zip archive, please wait";
    }
    return "Downloading " + (this.downloadFileIndex + 1) + " of " + this.totalDownloadCount + " files, please wait...";

  }
}

